import { createStore } from 'hox';
import { useState } from 'react';

import { RoleProps } from '@Types/administrator';

function useRoles() {
  const [roles, setRoles] = useState<RoleProps[] | []>([]);
  const [curRole, setCurRole] = useState<RoleProps | null>(null);
  return {
    roles,
    setRoles,
    curRole,
    setCurRole,
  };
}
export const [useRolesStore, RolesStoreProvider] = createStore(useRoles);
